const ROOT = ["integrations"] as const;

export const integrationKeys = {
	all: () => ROOT,
	catalog: () => [...ROOT, "catalog"] as const,
	user: () => [...ROOT, "user"] as const,
	mcpConfig: () => [...ROOT, "mcp-config"] as const,
};
